/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const PathIcon = ({
  className,
  style,
  onClick,
  color = '#3A50F3',
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2292 5.29167C14.1381 5.29167 14.875 4.5548 14.875 3.64583C14.875 2.73686 14.1381 2 13.2292 2C12.3202 2 11.5833 2.73686 11.5833 3.64583C11.5833 4.5548 12.3202 5.29167 13.2292 5.29167ZM13.2292 6.29167C14.6904 6.29167 15.875 5.10709 15.875 3.64583C15.875 2.18458 14.6904 1 13.2292 1C11.9389 1 10.8643 1.92365 10.6305 3.14583H7.9375V3.20486H7.4375V7.55556H5.24449C5.01074 6.33337 3.93615 5.40972 2.64583 5.40972C1.18458 5.40972 0 6.5943 0 8.05556C0 9.51681 1.18458 10.7014 2.64583 10.7014C3.93615 10.7014 5.01074 9.77774 5.24449 8.55556H7.4375V12.9062H7.9375V12.9653H10.6305C10.8643 14.1875 11.9389 15.1111 13.2292 15.1111C14.6904 15.1111 15.875 13.9265 15.875 12.4653C15.875 11.004 14.6904 9.81944 13.2292 9.81944C11.9389 9.81944 10.8643 10.7431 10.6305 11.9653H8.4375V4.14583H10.6305C10.8643 5.36802 11.9389 6.29167 13.2292 6.29167ZM13.2292 14.1111C14.1381 14.1111 14.875 13.3742 14.875 12.4653C14.875 11.5563 14.1381 10.8194 13.2292 10.8194C12.3202 10.8194 11.5833 11.5563 11.5833 12.4653C11.5833 13.3742 12.3202 14.1111 13.2292 14.1111ZM4.29167 8.05556C4.29167 8.96452 3.5548 9.70139 2.64583 9.70139C1.73686 9.70139 1 8.96452 1 8.05556C1 7.14659 1.73686 6.40972 2.64583 6.40972C3.5548 6.40972 4.29167 7.14659 4.29167 8.05556Z"
        fill={color}
      />
    </svg>
  );
};
